import { createAsyncThunk } from '@reduxjs/toolkit';
import { APIErrorMessage } from '../../../../../shared/infra/api/APIErrorMessage';
import { FilterQuery } from '../../../../../shared/types';
import { PaginationDataModel } from '../../../../../shared/components/pagination/model/Pagination.model';
import { GroupModel } from '../../../members/models/Groups.model';
import { groupService } from '../../services';

const getCommunityGroups = createAsyncThunk<
  PaginationDataModel<GroupModel[]>,
  FilterQuery,
  { rejectValue: APIErrorMessage }
>('groups/getCommunityGroups', async (query, thunkapi) => {
  const { offset, filter, dir, search } = query;
  const result = await groupService.getCommunityGroups(
    offset,
    filter,
    dir,
    search,
  );

  if (result.isLeft()) {
    const error = result.value;
    return thunkapi.rejectWithValue(error);
  } else {
    return result.value.getValue();
  }
});

export default getCommunityGroups;
